const reloadDelay = 5000

export function createPhiVisibilityController({
    livewire = window.Livewire,
    browserWindow = window,
} = {}) {
    const setLoaderVisibility = setTo => {
        browserWindow.dispatchEvent(new browserWindow.CustomEvent('show-full-loader', {
            detail: { setTo },
        }))
    }

    return {
        phiVisibilityUpdating: false,

        togglePhiVisibility(component) {
            if (this.phiVisibilityUpdating) return

            this.phiVisibilityUpdating = true
            setLoaderVisibility(true)

            const stopListeningForRequest = livewire.hook('request', ({ succeed, fail }) => {
                stopListeningForRequest()

                succeed(() => {
                    let navigationCompleted = false

                    browserWindow.addEventListener('livewire:navigated', () => {
                        navigationCompleted = true
                        setLoaderVisibility(false)
                    }, { once: true })

                    livewire.navigate(browserWindow.location.href, { preserveScroll: true })

                    browserWindow.setTimeout(() => {
                        if (!navigationCompleted) browserWindow.location.reload()
                    }, reloadDelay)
                })

                fail(() => {
                    this.phiVisibilityUpdating = false
                    setLoaderVisibility(false)
                })
            })

            component.togglePhiVisibility()
        },
    }
}
